/*global google_api_key:readonly siteLanguage:readonly*/

angular
    .module('b2bLoginApp')
    .config(["$httpProvider", "$interpolateProvider", "$uibTooltipProvider", "uiGmapGoogleMapApiProvider", "$compileProvider", "$uibModalProvider", "$provide", function ($httpProvider, $interpolateProvider, $uibTooltipProvider, uiGmapGoogleMapApiProvider, $compileProvider, $uibModalProvider, $provide) {
        if (process.env.APP_ENV === 'production') {
            $compileProvider.debugInfoEnabled(false);
        }

        // angular-google-maps 2.4.0's uiGmapExtendGWin.init only monkey-patches the
        // google.maps.InfoWindow / InfoBox prototypes. We use no info windows here (markers +
        // circles only), so that init is dead for us — and it now throws a TypeError on load
        // because the current Maps API made InfoWindow.prototype.isOpen getter-only. Skip it.
        $provide.decorator('uiGmapExtendGWin', ["$delegate", function ($delegate) {
            $delegate.init = angular.noop;

            return $delegate;
        }]);

        uiGmapGoogleMapApiProvider.configure({
            key: google_api_key,
            libraries: 'geometry,places',
            language: siteLanguage
        });

        $httpProvider.interceptors.push('LoadingInterceptor');
        $httpProvider.interceptors.push('NotificationFeedbackInterceptor');
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        $interpolateProvider.startSymbol('[[');
        $interpolateProvider.endSymbol(']]');

        $uibTooltipProvider.options({appendToBody: true});
        $uibModalProvider.options.windowClass = 'sd-modal';
    }]);
